(function () {
  'use strict';
  const sectionSelector = '[data-pdp-finish-first-finish-section], [data-pdp-pricing-finish-first-finish-section]';
  const cardSelector = '.variant-wrapper[data-handle="finish"], .option_frame_colour_new, .option_custom_frame_colour_new, .hanger_checkbox, .option_hanger_colour';

  function syncFinishGroupBorders(section) {
    const cards = Array.from(section.children).filter(card => card.matches(cardSelector));
    const visible = cards.filter(card => {
      if (card.hidden || card.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(card);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    cards.forEach(card => {
      const index = visible.indexOf(card);
      const first = index === 0;
      const last = index === visible.length - 1;
      // Inline priority overrides legacy adjacency/group classes without moving
      // controls or changing Infinite Options' visibility and selection state.
      const properties = index < 0 ? {} : {
        'border-top': first ? '1px solid var(--bd, rgba(0,0,0,.16))' : '0px',
        'border-bottom': last ? '1px solid var(--bd, rgba(0,0,0,.16))' : '0px',
        'border-left': '1px solid var(--bd, rgba(0,0,0,.16))',
        'border-right': '1px solid var(--bd, rgba(0,0,0,.16))',
        'border-top-left-radius': first ? 'var(--r, 14px)' : '0px',
        'border-top-right-radius': first ? 'var(--r, 14px)' : '0px',
        'border-bottom-left-radius': last ? 'var(--r, 14px)' : '0px',
        'border-bottom-right-radius': last ? 'var(--r, 14px)' : '0px',
        ...(!first ? { 'margin-top': '0px' } : {}),
        'margin-bottom': '0px',
        'box-shadow': 'none'
      };
      const applied = card.__pdpFinishBorderStyles || (card.__pdpFinishBorderStyles = {});
      // The first card's stylesheet margin provides clearance below the heading.
      // Only remove spacing between the visible controls joined into the group.
      if (first && applied['margin-top']) {
        card.style.removeProperty('margin-top');
        delete applied['margin-top'];
      }
      Object.entries(properties).forEach(([name, value]) => {
        const previous = applied[name];
        if (!previous || previous.value !== value || card.style.getPropertyValue(name) !== previous.serialized || card.style.getPropertyPriority(name) !== 'important') {
          card.style.setProperty(name, value, 'important');
          applied[name] = { value, serialized: card.style.getPropertyValue(name) };
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(sectionSelector).forEach(section => {
      if (section.dataset.finishGroupBordersBound === 'true') return;
      section.dataset.finishGroupBordersBound = 'true';
      let queued = false;
      const refresh = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          syncFinishGroupBorders(section);
        });
      };
      new MutationObserver(mutations => {
        // Only direct cards determine the outer border. Swatches, labels and
        // pricing inside a card can update without changing that geometry.
        if (mutations.some(mutation => mutation.target === section || (
          mutation.type === 'attributes' &&
          mutation.target.parentElement === section &&
          mutation.target.matches(cardSelector)
        ))) refresh();
      }).observe(section, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
      syncFinishGroupBorders(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
